<div class="flex flex-col items-stretch w-screen h-screen max-h-screen bg-zen-background fixed top-0 left-0 z-50 overflow-y-auto overflow-x-hidden">
  <ng-content></ng-content>
</div>